import React from 'react';
import {Styles} from '../../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import {Translate} from "../../../../config/Translate";
import {defaultVariabls} from "../../../../config/index";
import {withRouter} from "react-router-dom";
import { withSnackbar } from 'notistack';
import Grid from "@material-ui/core/Grid/Grid";
import {connect} from "trim-redux";
import Typography from "@material-ui/core/Typography/Typography";
import IconButton from "@material-ui/core/IconButton/IconButton";
import MoneyOffRoundedIcon from '@material-ui/icons/MoneyOffRounded';
import {currencySymbol, price} from "../../../../config/values";
import Link from "@material-ui/core/Link/Link";
import FeaturedPlayListOutlinedIcon from '@material-ui/icons/FeaturedPlayListOutlined';
import StorefrontOutlinedIcon from '@material-ui/icons/StorefrontOutlined';
import LocalShippingOutlinedIcon from '@material-ui/icons/LocalShippingOutlined';
import MonetizationOnOutlinedIcon from '@material-ui/icons/MonetizationOnOutlined';
import VerifiedUserOutlinedIcon from '@material-ui/icons/VerifiedUserOutlined';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import GetConfirmationText from "../../../components/elements/GetConfirmationText";
import Alert from "@material-ui/lab/Alert/Alert";
import AlertTitle from "@material-ui/lab/AlertTitle/AlertTitle";
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import axios from "axios";
import {updateRedux} from "../../../../config/Security";
import Tooltip from "@material-ui/core/Tooltip/Tooltip";
import InfoRoundedIcon from '@material-ui/icons/InfoRounded';

class SingleOrderItem extends React.Component {

    state = {
        item:this.props.item,
    };
    classes = this.props.classes;
    async changeProductVerification(verified){
        let {item} = this.state;
        let data = new FormData();
        data.append('id', item.id);
        data.append('verified', !!verified ? 1 : 0);

        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        await axios.post(`${defaultVariabls.url}/factor/change_product_verification`, data, config)
            .then(response => {
                this.props.reload();
            })
            .catch(error => {
                console.log(error.response)
                this.props.enqueueSnackbar(Translate.errorHappens, {
                    variant: 'error',
                });

            });

    }
    render(){
        let {product} = this.state.item;
        let {item} = this.state;
        return (
            <div style={{border:"1px solid",marginBottom:10,borderRadius:4,borderColor: !!item.need_verification ? "rgb(250, 207, 148)" :  "#eee"}}>

                <Grid container alignItems="center">
                    {
                        (!!item.need_verification && !this.props.view && this.props.factor_status === "need_verification") &&
                        <Grid item xs={12}>
                                <Alert
                                    severity="warning"
                                    action={
                                        <>
                                            <GetConfirmationText
                                                tooltip={Translate.confirmVerificationStatus}
                                                className={this.classes.link}
                                                style={{
                                                    cursor: "pointer",
                                                    color: "#fff",
                                                    backgroundColor: this.props.primary_color,
                                                    marginBottom: 0,
                                                    marginRight:10,
                                                    marginLeft:10,
                                                    borderRadius:5,
                                                    padding:"4px 10px"

                                                }}
                                                handleAction={() => this.changeProductVerification(true)}
                                                icon={<CheckBoxIcon/>}
                                                color={this.props.primary_color}
                                            >
                                                {Translate.verify_product}
                                            </GetConfirmationText>
                                            <GetConfirmationText
                                                tooltip={Translate.rejectVerificationStatus}
                                                className={this.classes.link}
                                                style={{
                                                    color: "#565656",
                                                    cursor: "pointer",
                                                    marginBottom: 0
                                                }}
                                                handleAction={() => this.changeProductVerification(false)}
                                                icon={<CloseRoundedIcon/>}
                                            >
                                                {Translate.reject_product}
                                            </GetConfirmationText>
                                        </>
                                    }
                                >
                                    <AlertTitle><strong>{Translate.need_verification_hint}</strong></AlertTitle>
                                    <Typography>{Translate.need_verification_hint_description}</Typography>
                                </Alert>
                        </Grid>
                    }
                    <Grid item xs={12} md={2} lg={2} className="text-center">
                        {
                            !!product &&
                            <Link href={`${defaultVariabls.website}/product/${product.slug}`} target="_blank">
                                <img
                                    src={`${defaultVariabls.uploads}/FileManager/${product.thumbnail.name}_book.${product.thumbnail.extension}`}
                                    alt="img"
                                    className="single-order-items-img"
                                />
                            </Link>
                        }

                    </Grid>
                    <Grid item xs={6} md={5} lg={5} className="single_order_items">
                        {
                            !!product &&
                            <Typography style={{marginBottom:10}}>
                            <IconButton size="small"><FeaturedPlayListOutlinedIcon/></IconButton>{Translate.product}: <strong>{product.name} {!!item.value ? " ("+item.value.attribute.name+" "+(item.value.attribute.type === "color" ? item.value.description : item.value.name) +") " : ''}</strong></Typography>
                        }

                        {
                            (!this.props.no_shop && !!item.shop) &&
                            <Typography  style={{marginBottom:10}}><IconButton size="small"><StorefrontOutlinedIcon/></IconButton>{Translate.shop}: <strong>{item.shop.name}</strong></Typography>

                        }
                        <Typography  style={{marginBottom:10}}><IconButton size="small"><MonetizationOnOutlinedIcon/></IconButton>{Translate.price}: <strong>{price(item.price*item.quantity)+" "+currencySymbol}</strong> <span style={{color:this.props.primary_color,fontSize:11}}>({item.quantity+" "+Translate.number})</span></Typography>

                    </Grid>
                    <Grid item xs={6} md={5} lg={5} className="single_order_items">
                        {
                            !!item.need_verification &&
                            <Tooltip title={Translate.need_verification_description_user} arrow>
                                <Typography  style={{marginBottom:10}}>
                                    <IconButton size="small"><InfoRoundedIcon/></IconButton>
                                    <strong>{Translate.need_verification_hint}</strong>
                                </Typography>
                            </Tooltip>
                        }

                        {
                            item.discount_price ?
                                <Typography  style={{marginBottom:10,color:"#f82e4e"}} ><IconButton size="small"><MoneyOffRoundedIcon color="primary" /></IconButton>{Translate.discount}: <strong>{price((parseInt(item.discount_price))*item.quantity)+" "+currencySymbol}</strong></Typography>
                                : null
                        }
                    </Grid>
                </Grid>
            </div>
        );
    }
}

const mstp = state => ({
    isAuth: state.isAuth,
    user: state.user,
    primary_color: state.primary_color
});
export default withRouter(withSnackbar(withStyles(Styles)(connect(mstp)(SingleOrderItem))));